import { gql } from '@apollo/client';

export const LIST_ACTIVITIES = gql`
  query getActivities($search: SearchActivityInput!) {
    listActivities(search: $search) {
      docs {
        _id
        name
        type
        disable
        finished
        started
        status
        draf
      }
      limit
      page
      totalDocs
      totalPages
    }
  }
`;

export const ListRoads = gql`
  query ListRoads($search: SearchRoadsInput!) {
    listRoads(search: $search) {
      docs {
        name
        _id
        description
        membership
        cover
        rate
        status
        new
        started
        finished
        challenge
        draf
      }
      page
      limit
      totalDocs
      totalPages
    }
  }
`;

export const GET_EPISODE_BY_NAME = gql`
query GetEpisodeByName($name: String!) {
  getEpisodeByName(name: $name) {
    page
    limit
    totalDocs
    totalPages
    docs {
        _id
        title
        cover
      }
  }
}
`;

export const LIST_EPISODES_FILTER_BY_TAGS = gql`
  query ListEpisodesFilterByTags($tags: [ObjectId!]!) {
    listEpisodesFilterByTags(tags: $tags) {
      docs {
        _id
        title
        cover
      }
    }
  }
`;

export const ListEpisodes = gql`
  query ListEpisodes($search: SearchEpisodeInput!) {
    listEpisodes(search: $search) {
      docs {
        _id
        title
        cover
        status
        activity
        draf
        gender
        pillars {
          emotions
          relations
          transformation
          selfEsteem
          purpose
        }
        tags {
          _id
          name
        }
      }
      page
      limit
      totalDocs
      totalPages
    }
  }
`;

// ** Activities

export const FilterActivities = gql`
  query filterActivities($search: SearchActivityInput!) {
    listActivities(search: $search) {
      docs {
        _id
        name
      }
      limit
      page
      totalDocs
      totalPages
    }
  }
`;


export const ListUsersByEpisodes = gql`
query ListUsersByEpisodes($roadId: ObjectId!) {
  listUsersByEpisodes(roadId: $roadId) {
    title
    description
    users {
      fullName
      email
    }
  }
}
  `;